import React from "react";
import { AddBox, AirportShuttle, ArrowDownward, ArrowUpward, Info, LocalTaxi, PeopleAlt, Settings } from '@material-ui/icons';
// routes
import { Badge, QueryStats } from "@mui/icons-material";
import { iconMap } from "../../contexts/BookingUtilities";
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import SvgIconStyle from '../../components/SvgIconStyle';
import { getFPCoRoutes, getRootAdminRoutes, getSchoolRoutes, getTravelCoRoutes } from "../../routes/dashboard.routes";



// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle
    src={`/static/icons/navbar/${name}.svg`}
    sx={{ width: 22, height: 22 }}
  />
);

const ICONS = {
  page: getIcon('ic_page'),
  dashboard: getIcon('ic_dashboard')
};

const getNavFromConfig = (routes) => {
  const items = [];
  
	for(let i=0; i<routes.length; i+=1){
		const {
			title='',
			icon=null,
			path='',
			mainNav=true,
      queryString=''
		} = routes[i];
		if(mainNav){



			items.push({
				title,
				icon,
				path,
        queryString
			});
		}
	}
	return [
    	{
			subheader: 'general',
			items
		}
	];
}

export const getSidebarConfigRootAdmin = (profileContext,brandContext) => getNavFromConfig(getRootAdminRoutes(profileContext,brandContext));

export const sidebarConfigSchoolAdmin = (profileContext,brandContext) => getNavFromConfig(getSchoolRoutes(profileContext,brandContext,'nav'));

export const sidebarConfigFpCo = (profileContext,brandContext,selectorContext) =>  getNavFromConfig(getFPCoRoutes(profileContext,brandContext,selectorContext));

export const sidebarTravelCo = (profileContext,brandContext,selectorContext) =>  getNavFromConfig(getTravelCoRoutes(profileContext,brandContext,selectorContext));

export const callToActionTools = (brandContext,callToActionContext) => {
  
  const {
    textContent:{
      adminBookAPass='',
      adminBookATaxi='',
      adminMakeABookingButton='',
      adminGetHelpButton='',
    },
    brand:{
      parentPortal=''
    }
  } = brandContext;

  const {
    setState=null
  } = callToActionContext;

  return[
  {
    title:adminBookATaxi,
    icon:iconMap.LocalTaxi,
    action: () => {
      setState({showTaxiBookingDialogue:true})
    }
  },
  {
    title:adminMakeABookingButton,
    icon:<AddBox/>,
    action: () => {
      window.open(parentPortal);
    }
  },
  {
    title:adminGetHelpButton,
    icon:<Info/>,
    action: () => {
      window.open('https://help.i-gtm.com');
    }
  },
  ];
}


